module.exports = __webpack_public_path__ + "static/media/five_monkey.1a1f9827.png";